import { Button, Column, Row } from '@grubhubprod/gh-cookbook-react';
import { isEmpty } from '@grubhubprod/umami-library/dist/nodash/isEmpty';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { BudgetCurrencyInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/CurrencyInput/BudgetCurrencyInput';
import { GroupSelectSearch } from 'src/components/oneCorp/features/MealCredit/common/formFields/SelectSearch/GroupSelectSearch';
import {
  getDefaultGroupFormValues,
  GroupFormFields,
} from 'src/components/oneCorp/features/MealCredit/components/Groups/GroupForm/GroupForm.utils';
import { LocTagInvite } from 'src/types/LineOfCredit';

export interface GroupFormProps {
  onHandleForm: (formFields: GroupFormFields) => void;
  onCancel?: () => void;
  initGroup?: LocTagInvite;
  tagInvites: LocTagInvite[];
  isAdding?: boolean;
}

export function GroupForm({
  onCancel,
  onHandleForm,
  initGroup,
  tagInvites = [],
  isAdding = false,
}: GroupFormProps): JSX.Element {
  const useFormProps = useForm<GroupFormFields>({
    mode: 'onChange',
    defaultValues: getDefaultGroupFormValues(initGroup),
  });
  const { handleSubmit, formState, register, errors } = useFormProps;
  const { isValid, isSubmitting } = formState;

  useEffect(() => {
    register('name');
  }, [register]);

  return (
    <FormProvider {...useFormProps}>
      <form>
        <Row alignItems={isEmpty(errors) ? 'center' : 'top'}>
          <Column gutter={12} phone={6} tablet={6} desktop={4}>
            <GroupSelectSearch
              name="id"
              tagInvites={tagInvites}
              initGroup={initGroup}
            />
          </Column>
          <Column gutter={8} phone={3}>
            <BudgetCurrencyInput id="budget" name="budget" />
          </Column>
          <Column gutter={8} phone={3} tablet={3} desktop={2}>
            <Button
              variant="primary"
              block
              buttonSize="small"
              disabled={!isValid || isSubmitting || isAdding}
              isLoading={isSubmitting || isAdding}
              onClick={handleSubmit((groupFormFields) =>
                onHandleForm(groupFormFields)
              )}
            >
              Save
            </Button>
          </Column>
          <Column gutter={8} phone={3} tablet={2} desktop={2}>
            <Button
              disabled={isSubmitting}
              buttonSize="small"
              variant="tertiary"
              block
              type="button"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Column>
        </Row>
      </form>
    </FormProvider>
  );
}
